import React from 'react';
import styled from 'styled-components';
import { Header1, Header3 } from '@ubeya/shared-web/components';

const Title = styled(Header1)`
  text-align: center;
  margin: 10px auto;
`;

const SubTitle = styled(Header3)`
  text-align: center;
  margin: 10px auto;
`;

const PDFTitle = ({ title, subTitle }) => (
  <>
    <Title>{title}</Title>

    {subTitle && <SubTitle>{subTitle}</SubTitle>}
  </>
);

export default PDFTitle;
